<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Certificates',
                link: {
                    name: 'aUT Certificates',
                },
            },
            {
                name: `${certificate ? certificate.commonName : 'aUT Certificate'}`,
                link: {
                    name: 'aUT Certificate',
                    params: {
                        id: ` `,
                    },
                },
                closeTab: true,
                disable: true,
            },
        ]" pretitle="aqfer Universal Tag" :breadcrumbTitle="true" :editMode="editMode" @nav-close-clicked="closeClick">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a @click="closeClick" href="#" class="h1">aUT Certificates</a>
                        </li>
                        <li class="breadcrumb-item active h1" aria-current="page">
                            {{ currentPage }}
                        </li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <div class="custom-btn-group">
                    <span v-if="certDeploy && Object.keys(certDeploy.warnings).length !== 0">
                        <button type="button" @click.prevent="this.showModal({ component: 'AcknowledgeDenyWarnings', data: this.certDeploy })" class="btn btn-warning">
                            Acknowledge/Deny Warnings
                        </button>
                    </span>
                    <span v-if="certDeploy && certDeploy.deployment_status === 'wait-upload-third-party'">
                        <button type="button" @click.prevent="this.showModal({ component: 'GetCertificateCSR', data: this.certDeploy })" class="btn btn-success">
                            Get CSR
                        </button>
                    </span>
                    <span v-if="certDeploy && certDeploy.deployment_status === 'wait-upload-third-party'">
                        <button type="button" @click.prevent="this.showModal({ component: 'UpdateSignedCertificate', data: this.certDeploy })" class="btn btn-primary">
                            Upload Signed Certificate
                        </button>
                    </span>
                    <span v-if="certificate">
                        <button type="button" @click.prevent="this.showModal({ component: 'RenewCertificate', data: this.certificate })" class="btn btn-info">
                            Renew Certificate
                        </button>
                    </span>
                    <span v-if="certificate">
                        <button type="button" @click.prevent="onDeleteClick()" class="btn btn-danger">
                            Delete
                        </button>
                    </span>
                    <span v-else>
                        <button type="button" @click.prevent="showModal({ component: 'addCertificate' })"
                            class="btn btn-primary">
                            Create Certificate
                        </button>
                    </span>
                </div>

            </template>
        </nav-header>
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div>
            <router-view v-on:setCertificate="setCertificate" v-on:setCertDeploy="setCertDeploy">
            </router-view>
        </div>
    </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
export default {
    components: { NavHeader },
    data() {
        return {
            error: null,
            certificate: null,
            certDeploy: null,
            currentPage: "Certificates",
        };
    },
    watch: {
        "$route.params.id": {
            handler: function (to, from) {
                if (!to) {
                    this.closeClick();
                }
            },
        },
        '$store.state.aut.deleteCertTrigger' :{
            handler(newValue) {
                this.closeClick()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
        }),
        setCertificate(certificate) {
            this.certificate = certificate;
        },
        setCertDeploy(certDeploy) {
            this.certDeploy = certDeploy;
        },
        closeClick() {
            this.certificate = null;
            this.certDeploy = null;
            this.$router.push({
                name: "aUT Certificates",
            });
        },
        onDeleteClick() {
            this.showModal({ component: "deleteCertificate", data: [this.certificate] })
        },
    },
};
</script>

<style scoped>
.custom-btn-group {
    display: flex;
    align-items: center;
}

.btn {
    margin-right: 12px;
}
</style>